import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useRemoveQueryParams } from 'js/hooks/navigate';
import { getCookie, setCookie, removeCookie } from 'js/utils/cookie.util';

export const COOKIE_NAME = 'draft_theme';

export const useDraftThemeCookie = () => {
    const cookieThemeName = getCookie(COOKIE_NAME);
    const { search } = useLocation();
    const searchParams = useMemo(() => new URLSearchParams(search), [search]);
    const themeName = searchParams.get('themeName');
    const removeQueryParams = useRemoveQueryParams();

    useEffect(() => {
        if (themeName === null) {
            return;
        }

        if (themeName && themeName !== cookieThemeName) {
            setCookie(COOKIE_NAME, themeName, {
                path: '/'
            });
        }

        if (!themeName) {
            removeCookie(COOKIE_NAME, {
                path: '/'
            });
        }

        removeQueryParams(['themeName']);
        window.location.reload();
    }, [themeName, cookieThemeName, removeQueryParams]);
};
